import { IDisposable } from 'common/disposable';
import { List } from 'immutable';

export class CallQueue implements IDisposable {
    private queue = List<Function>();
    private processing: boolean;
    private disposed = false;

    constructor() {
        this.processing = false;
    }

    enqueue(action: Function) {
        if (this.disposed)
            return;

        if (this.processing) {
            this.queue = this.queue.push(action);
        }
        else {
            this.processing = true;
            action();
        }
    }

    proceed() {
        if (this.queue.count() > 0) {
            const f = this.queue.first();
            this.queue = this.queue.shift();
            f();
        } else {
            this.processing = false;
        }
    }

    clear() {
        this.queue = this.queue.clear();
        this.proceed();
    }

    dispose() {
        if (this.disposed)
            return;

        this.disposed = true;
        this.clear();
    }
}